import { createRoot } from 'react-dom/client'
import Main from './app';
const container = document.getElementById('root');
 
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Main tab="home" />);

 